import { getOrderPayments } from 'common/modules/atoms/paymentAmounts';
import { OrderInfo } from 'common/types';
import { DTAOrderStatuses } from 'common/types';

export interface FilterOption<T> {
	value: T;
	label: string;
}

export enum StatusFilter {
	ALL = 'ALL',
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	CANCELED = 'CANCELED',
}

export enum PaymentFilter {
	ALL = 'ALL',
	PAID = 'PAID',
	REFUNDED = 'REFUNDED',
	UNPAID = 'UNPAID',
}

export const isDTAOrderCanceled = (DTAOrderStatus: DTAOrderStatuses | undefined) =>
	DTAOrderStatus === DTAOrderStatuses.CANCELLED;

export const isDTAOrderCompleted = (DTAOrderStatus: DTAOrderStatuses | undefined) =>
	DTAOrderStatus === DTAOrderStatuses.RESERVED ||
	DTAOrderStatus === DTAOrderStatuses.BOOKED_AND_TRANSFERRED;

export const filterOrders = (
	orders: OrderInfo[],
	statusFilter: StatusFilter,
	paymentFilter: PaymentFilter,
) =>
	orders.filter((order) => {
		const DTAOrderStatus = order.skidataProps?.DTAOrderStatus;
		const isCanceled = isDTAOrderCanceled(DTAOrderStatus);
		const isCompleted = order.rentalState === 'COMPLETED' || isDTAOrderCompleted(DTAOrderStatus);
		const isCorrectStatus =
			statusFilter === StatusFilter.CANCELED
				? isCanceled
				: statusFilter === StatusFilter.COMPLETED
				? isCompleted && !isCanceled
				: statusFilter === StatusFilter.PENDING
				? !isCompleted && !isCanceled
				: true;

		const chargePayment = getOrderPayments(order).charge;
		const notPaid = chargePayment.unpaid > 0;
		const isCorrectPayment =
			paymentFilter === PaymentFilter.PAID
				? !notPaid
				: paymentFilter === PaymentFilter.UNPAID
				? notPaid
				: true;

		return isCorrectStatus && isCorrectPayment;
	});

export const filterOrdersByLocation = (
	orders: OrderInfo[],
	locationId: string,
	locationType: 'all' | 'current',
) => orders.filter((order) => locationType === 'all' || order.startLocation.id === locationId);
